import { createSlice } from "@reduxjs/toolkit";

const paymentEnrollmentFormSlice = createSlice({
  name: "paymentEnrollmentForm",
  initialState: {
    enrollmentErrors: {},
    enrollmentInfo: {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
      phoneNumber: "",
    },
    hasErrors: true,
  },
  reducers: {
    updatePaymentEnrollmentFormState(state, action) {
      return Object.assign({}, state, action.payload);
    },
  },
});

export const {
  updatePaymentEnrollmentFormState,
} = paymentEnrollmentFormSlice.actions;

export default paymentEnrollmentFormSlice.reducer;
